<template>
  <div class="main container">
    <loader :isLoading="isRequestInProgress" />

    <div v-if="!isRequestInProgress">
      <h2>{{ companyName }}</h2>

      <div class="line"></div>

      <ProfileForm
        v-if="isToEditForm"
        :form="companyDetails"
        :useCategories="useCategories"
        :previewImage="previewImage"
        :validateForm="validateForm"
        :isToEditForm="isToEditForm"
        :updateErrorState="updateErrorState"
        :errorMessage="errorMessage"
      />

      <ProfileViewDetail
        v-else
        :companyDetails="companyDetails"
        :changeToEditForm="changeToEditForm"
        :previewImage="previewImage"
      />
    </div>
  </div>
</template>

<script>
import { ASSIGN_CURRENT_COMPANY } from '@/store/types/actions.type'

import Loader from '@/components/common/Loader'

import ProfileForm from './ProfileForm'
import ProfileViewDetail from './ProfileViewDetail'

import { USE_YEYPASS } from '@/api/constants/Business'

import { APIService } from '@/api/APIService'
const api = new APIService()

const placeholderImage = 'http://placehold.jp/ebf0f5/9db4cc/150x150.png?text=YP'
const MAX_SIZE_PROFILE = 2097152

export default {
  components: {
    Loader,
    ProfileForm,
    ProfileViewDetail
  },
  data() {
    return {
      accountType: '',
      companyId: '',
      userId: '',
      companyName: '',
      profilePicture: placeholderImage,
      errorMessage: '',
      imageData: '',
      companyDetails: {},
      useCategories: USE_YEYPASS,
      isRequestInProgress: true,
      isToEditForm: false,
      haveVuelidateError: false,
      haveError: false
    }
  },
  props: {
    company: Object
  },
  watch: {
    company(newVal, oldVal) {
      if (newVal.company_details) this.setValues()
    }
  },
  mounted() {
    if (this.company.company_name) this.setValues()
  },
  methods: {
    setValues() {
      this.isRequestInProgress = false
      this.companyId = this.company.id
      this.companyName = this.company.company_name
      this.companyDetails = this.company.company_details
      this.profilePicture =
        this.company.company_details.company_logo_url || placeholderImage
    },
    toTitleCase(str) {
      return str.replace(/(^|\s)\S/g, function(t) {
        return t.toUpperCase()
      })
    },
    changeToEditForm() {
      this.isToEditForm = !this.isToEditForm
    },
    updateErrorState(value) {
      this.haveVuelidateError = value
    },
    previewImage(event) {
      this.error = ''
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        var file = input.files[0]
        if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
          this.error = 'File type not supported. Select png or jpeg'
          return
        }
        if (file.size > MAX_SIZE_PROFILE) {
          this.error = 'Please upload image up to 2mb'
          return
        }
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.image_data" refers to the image_data of Vue component
          // Read image as base64 and set to image_data
          // this.$store.dispatch(SET_PROFILE_PICTURE, e.target.result)
          this.imageData = e.target.result
          this.submitPhoto()
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(file)
      }
    },
    validateForm() {
      this.errorMessage = ''
      this.haveError = false

      if (this.haveError || this.haveVuelidateError) {
        this.errorMessage =
          'You might have missed out a field.' +
          'Please check the errors shown and update the details. Thank you! :)'
      } else {
        this.patchChanges()
      }
    },
    async patchChanges() {
      this.isRequestInProgress = true
      const fields = { company_details: { ...this.companyDetails } }
      const updates = await api.updateCompanyProfile(this.companyId, fields)
      if (updates.statusCode === 400) {
        this.errorMessage = updates.message
      } else {
        this.isToEditForm = false
      }
      this.isRequestInProgress = false
    },
    async submitPhoto() {
      try {
        this.isRequestInProgress = true
        const fields = { image_url: this.imageData }
        const uploadImage = await api.uploadImage(fields)
        const companyLogo = {
          company_details: { company_logo: uploadImage.object_name }
        }
        this.updateCompanyDetails(companyLogo)
      } catch (err) {
        this.error = err
        this.isRequestInProgress = false
      }
    },
    async updateCompanyDetails(field) {
      try {
        const update = await api.updateCompanyProfile(this.companyId, field)
        if (update.statusCode === 400) this.error = update.message
        else {
          const companyRecord = await api.getCompanyDetails(this.companyId)
          if (companyRecord.statusCode === 400)
            console.log('something went wrong')
          else this.$store.dispatch(ASSIGN_CURRENT_COMPANY, companyRecord)
        }
        this.isRequestInProgress = false
      } catch (err) {
        this.error = err
        this.isRequestInProgress = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/containers/business_profile/CompanyProfile.vue